import { useMutation, useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchCompanies } from "../api/companies.api";

import { useEffect } from "react";

const useCompanies = () => {
  const [
    bearerToken,
    setCompanyId,
    companyId,
    setCompanyName,
    organizationId,
    organizationName,
    setOrganizationName,
  ] = useUIStore(
    useShallow((state: UIState) => [
      state.bearerToken,
      state.setCompanyId,
      state.companyId,
      state.setCompanyName,
      state.organizationId,
      state.organizationName,
      state.setOrganizationName,
    ])
  );

  // Fetch all companies for user
  const {
    data: companiesData,
    error: companiesError,
    isLoading: isLoadingCompanies,
    isSuccess: isCompaniesSuccess,
  } = useQuery({
    queryKey: ["companies"],
    queryFn: () => fetchCompanies(bearerToken as string),
    enabled: !!bearerToken,
  });

  // if there is no selected company, set the first company as selected
  useEffect(() => {
    if (!!companiesData?.length && !companyId) {
      setCompanyId(companiesData[0].id);
      setCompanyName(companiesData[0].companyName);
    }

    if (
      !!companiesData?.length &&
      companyId &&
      organizationId &&
      !organizationName
    ) {
      const selectedCompany = companiesData.find(
        (company) => company.id === companyId
      );
      const selectedOrganization = selectedCompany?.organizations.find(
        (org) => org.id === organizationId
      );
      if (selectedOrganization) {
        setOrganizationName(selectedOrganization.organizationName);
      }
    }
  }, [companiesData, companyId, setCompanyId]);

  return {
    companies: companiesData,
    companiesError,
    isLoadingCompanies,
    isCompaniesSuccess,
  };
};

export default useCompanies;
